import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, CircularProgress, Dialog, Stack, Typography } from "@mui/material";
export const FullScreenLoadingDialog = ({ open, text }) => (_jsx(Dialog, Object.assign({ open: open, fullScreen: true, PaperProps: {
        sx: { backgroundColor: "transparent", boxShadow: "none" },
    }, slotProps: {
        backdrop: {
            sx: {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                backdropFilter: "blur(8px)",
                transition: "none", // Remove transition for instant effect
            },
        },
    } }, { children: _jsx(Stack, Object.assign({ sx: {
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
        } }, { children: _jsx(Card, Object.assign({ sx: (theme) => ({
                borderRadius: theme.spacing(2),
                backgroundColor: "rgba(255,255,255,0.75)",
                boxShadow: theme.shadows[8],
            }) }, { children: _jsxs(CardContent, Object.assign({ sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 200,
                    minHeight: 200,
                } }, { children: [_jsx(CircularProgress, { size: 80, thickness: 3, sx: { mb: 2 } }), !!text && (_jsx(Typography, Object.assign({ variant: "h3", align: "center" }, { children: text })))] })) })) })) })));
